<template lang="pug">
v-card(class="pa-0")
    p Plan a trip
    v-row(v-for="trip in trips" "v-bind:key"="trip.id" align="baseline")
      v-col(cols=1)
        v-btn(x-small fab :color="(selectedTrip != null && trip.id == selectedTrip.id) ? 'warning' : ''" @click="selectionChanged(trip)" )
          v-icon mdi-eye
      v-col(cols=11)
        PlannerTripCard(:trip="trip" :expanded="trip.title == 'Give this trip a name'", @remove="removeTrip" :editTitle="trip.title == 'Give this trip a name'" :colour="colourForTrip(trip.id)" @tripUpdated="tripUpdated" :myAddress="myAddress")

    v-row
      v-col(cols=4)
        v-tooltip(right)
          template("v-slot:activator"="{ on }")
            v-btn(v-on:click="addTrip" fab small class="primary" v-on="on") 
              v-icon mdi-plus
          span Add Trip
      v-col(cols=8 class="right")
        v-btn(color="primary" class="mx-4" @click="$emit('next')") Next
</template>

<script>
import PlannerTripCard from "./PlannerTripCard.vue";

export default {
  props: ["trips","selectedTrip", "myAddress"],
  components: {
    PlannerTripCard
  },
  data() {
    return {};
  },
  methods: {
    selectionChanged(trip) {
      this.$emit("selectionChanged",trip);
    },
    tripUpdated() {
      this.$emit("tripUpdated");
    },
    addTrip() {
      this.trips.push({
        id: this.trips.length + 1,
        title: "Give this trip a name",
        frequency: 5,
        frequencyUnit: "week",
        viaAddresses: [],
        fromAddress: { Address: null },
        toAddress: { Address: null },
        path: []
      });
    },
    removeTrip(trip) {
      if (trip.selected) {
        this.$emit("selectionChanged",null);
      }
      this.trips.splice(
        0,
        this.trips.length,
        ...this.trips.filter(e => e.id !== trip.id)
      );
    }
  },
  mounted: function() {
    if (this.trips.length == 0) {

      this.trips.push({
        id: this.trips.length + 1,
        title: "Give this trip a name",
        frequency: 5,
        frequencyUnit: "week",
        viaAddresses: [],
        fromAddress: { Address: null },
        toAddress: { Address: null },
        path: []
      });
      this.selectionChanged(this.trips[0])
    }
  }
};
</script>

<style scoped>
.right {
  text-align: right;
}
</style>